module.exports = __webpack_public_path__ + "static/img/banner-202002.ab9e7a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner-202002.jpg
// module id = JRkC
// module chunks = 5